import { Component } from '@angular/core';
import { ListRequisitionComponent } from '../list-requisition/list-requisition.component';

@Component({
	selector: 'app-list-requisition2',
	templateUrl: './list-requisition2.component.html',
	styleUrls: ['../list-requisition/list-requisition.component.css']
})
export class ListRequisition2Component extends ListRequisitionComponent {

	ngOnInit()
	{
		super.ngOnInit();
		this.path = '/list-requisition2/' + this.type;
	}
}
